import React from 'react';
import './footerLoader.scss';

const FooterLoader = () => {
  return (
    <div className="footer_loader">
      <div class="shimmer_box">
        <div className="box_inside">
          <div className="inside-plan">
            <div className="plan-info">
              <div class="text">
                <span class="visual"></span>
              </div>
              <div class="text text_l">
                <span class="visual"></span>
              </div>
              <div class="text text_m">
                <span class="visual"></span>
              </div>
            </div>
            <div className="plan-details">
              <ul className="item_list">
                <li>
                  <div class="text">
                    <span class="visual"></span>
                  </div>
                  <div class="text text_m">
                    <span class="visual"></span>
                  </div>
                </li>
                <li>
                  <div class="text">
                    <span class="visual"></span>
                  </div>
                  <div class="text text_l">
                    <span class="visual"></span>
                  </div>
                </li>
                <li>
                  <div class="text">
                    <span class="visual"></span>
                  </div>
                  <div class="text text_s">
                    <span class="visual"></span>
                  </div>
                </li>
              </ul>
              <div className="action">
                <div class="text">
                  <span class="visual"></span>
                </div>
                <div class="text">
                  <span class="visual"></span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default FooterLoader;
